import React from "react";
import { ARTIST } from "@/constants/testIds";
import { Ornament } from "@/components/Logo";

export default function ArtistStory() {
  return (
    <section
      id="artist"
      data-testid={ARTIST.root}
      className="relative bg-[#0B3B24] text-ivory py-24 md:py-32 overflow-hidden"
      style={{ color: "var(--ivory)" }}
    >
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#D4AF37]/10 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 w-[520px] h-[520px] rounded-full bg-[#722F37]/25 blur-3xl" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 sm:px-10 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-5">
          <div className="relative">
            <div className="absolute inset-0 -m-4 border border-[#D4AF37] pointer-events-none" />
            <img
              src="/tom-pergola-studio.jpg"
              alt="Tom Pergola in the studio"
              className="w-full aspect-[4/5] object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <div className="text-[10px] tracking-[0.5em] uppercase text-[#D4AF37]">
            The Master Artist
          </div>
          <h2
            data-testid={ARTIST.heading}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 tracking-tight font-light"
          >
            Tom Pergola.
            <br />
            <em className="italic opacity-80">King of pop art.</em>
          </h2>

          <div className="mt-8 w-40">
            <Ornament color="#D4AF37" />
          </div>

          <div className="mt-8 space-y-5 text-base leading-relaxed text-ivory/85">
            <p>
              Tom Pergola is recognized as one of the most prolific and
              innovative fine artists on the contemporary art scene &mdash; a
              career spanning mixed-media sculpture, celebrity portraiture and
              pop-forward assemblage.
            </p>
            <p>
              His signature medium is <em>assemblage plastique</em>: everyday
              objects &mdash; candy, food, packaging, household relics &mdash;
              locked into resin-coated tableaus and full-scale figurative
              pieces. Alongside them runs a body of acrylic paintings and
              commissioned celebrity works.
            </p>
            <p>
              His work has climbed billboards on Sunset Boulevard and Times
              Square, been licensed by <strong>Kellogg&rsquo;s</strong>, and
              seen him named official sculptor for <strong>Pinnacle</strong>.
              His pieces sit in the personal orbit of Jay Leno, Carol Burnett,
              Mark Kostabi and President Donald Trump.
            </p>
            <p>
              Under the custodianship of the House of Master Brushes Fine Art,
              a curated selection is now open for private reservation. Every
              purchase is honoured personally by Edgar Hicks and escrowed
              through Escrow.com so collectors receive the piece before funds
              release.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "Years in studio", v: "40+" },
              { k: "Signature works", v: "180+" },
              { k: "Licensed by", v: "Kellogg's · Pinnacle" },
            ].map((s) => (
              <div key={s.k}>
                <div className="font-serif text-2xl md:text-3xl text-[#D4AF37] leading-tight">
                  {s.v}
                </div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-ivory/60 mt-2">
                  {s.k}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
